<template>
    <div class="out-container">
        <create-all :isDetail="isDetail" ref="all_examine" :examineId="examineId" v-if="opt == 'all_examine'"
            @examine_success="pageQueryExamine"></create-all>
        <all-examine-detail ref="all_examine_detail" v-else-if="opt == 'all_examine_detail'"></all-examine-detail>
        <view-paper ref="view_paper" :examineId="examineId" v-else-if="opt=='view_paper'"></view-paper>
        <div class="examine-box" v-else>
            <div class="top-box">
                <div class="btn-box" @click="createExamine">
                    <i class="iconfont icon-jiahao"></i>
                    创建考核
                </div>
                <div class="input-box">
                    <div @click="search">搜索</div>
                    <el-input v-model="pages.keywords" style="width: 20rem;" clearable @clear="search"
                        @keydown.enter.native="search" placeholder="请输入关键字">
                        <template slot="prefix">
                            <div class="search-ipt-box">
                                <img style="cursor: pointer;width: 16px;height: auto;"
                                    src="../../../assets/image/magSys/search.png" @click="search" alt="">
                            </div>
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="content-box">
                <Table :totalSize="pages.total" :pagination="true" :serialNumber="true" :operationWidth="350"
                    :currentPage="pages.current" @changeCurrentPage="changeCurrentPage" @changePageSize="changePageSize"
                    :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData" :tableKey="tableKey">
                    <template slot="completed" slot-scope="data">
                        <p class="examine-number" @click="viewPersonNum(data.data.row, 'completed')">{{
                            data.data.row.completed }}</p>
                    </template>
                    <template slot="incomplete" slot-scope="data">
                        <p class="examine-number" @click="viewPersonNum(data.data.row, 'incomplete')">{{
                            data.data.row.incomplete }}</p>
                    </template>
                    <template slot="examineName" slot-scope="data">
                        <p class="examine-number" @click="viewExamineDetail(data.data.row)">{{
                            data.data.row.examineName }}</p>
                    </template>
                    <template slot="examineStatus" slot-scope="data">
                        <p>{{ filterStatus(data.data.row.examineStatus).label }}</p>
                    </template>
                    <template slot="score" slot-scope="data">
                        <p class="examine-number" @click="viewExamineDetail(data.data.row)">查看</p>
                    </template>
                    <template slot="operation" slot-scope="data">
                        <div class="operation-box">
                            <el-tooltip class="item" effect="dark" content="试卷预览" placement="top-start">
                                <i class="iconfont icon-yulan" style="margin-right: 2rem;font-size: 2rem;" @click="view(data.data.row)"></i>
                            </el-tooltip> 
                            <el-tooltip class="item" effect="dark" content="详情" placement="top-start">
                                <i class="iconfont icon-xiangqing" @click="detail(data.data.row)"
                                    style="margin-right: 2rem;"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                <i class="iconfont icon-bianji1" @click="edit(data.data.row)"
                                    style="margin-right: 2rem;"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                <i class="iconfont icon-shanchu" @click="deleteExamine(data.data.row.id)"></i>
                            </el-tooltip>
                        </div>
                    </template>
                </Table>
            </div>
        </div>
        <examine-person ref="examine_person"></examine-person>
    </div>
</template>

<script>
import { DeleteExamine, PageQueryExamine, GetExamineDetailById, GetExamineExcludeQuestionIds, GetSoftwareConfigScore,PageQuerySoftwareScore,GetSynthExamineDetailById  } from '@/api/examine';
import { GetTestPaperInfo } from '@/api/paper';
import CreateAll from './all/CreateAll.vue';
import ExaminePerson from './virtual/ExaminePerson.vue';
import AllExamineDetail from './all/AllExamineDetail.vue';
import ViewPaper from '../../personCenter/myselfPaper/ViewPaper.vue';
export default {
    components: { CreateAll, ExaminePerson, AllExamineDetail, ViewPaper },
    data() {
        return {
            pages: {
                current: 1,
                size: 10,
                total: 0,
                keywords: ''
            },
            isDetail: false,
            tableKey: [
                {
                    name: '考核名称',
                    value: 'examineName',
                    slot:'examineName'
                },
                {
                    name: '开始时间',
                    value: 'beginTime',
                },
                {
                    name: '结束时间',
                    value: 'endTime',
                },
                {
                    name: '考核状态',
                    value: 'examineStatus',
                    slot: 'examineStatus'
                },
                {
                    name: '已考核人员',
                    value: 'completed',
                    slot: 'completed'
                },
                {
                    name: '未考核人员',
                    value: 'incomplete',
                    slot: 'incomplete'
                },
                {
                    name: '合格率',
                    value: 'rate',
                },
                {
                    name: '成绩',
                    slot: 'score'
                },
                {
                    name: '操作',
                    value: 'operation',
                    slot: 'operation'
                },
            ],
            /**列表数据 */
            tableData: [],
            examineId: '',
        }
    },
    computed: {
        opt() {
            return this.$store.state.course.operation;
        }
    },
    methods: {
        search() {
            this.pages.current = 1;
            this.pageQueryExamine();
        },
        /**试卷预览 */
        view(item){
            this.examineId=item.id;
                this.$store.commit('course/changeOperation','view_paper');
                this.$store.commit('backend/changeOptlabel','试卷预览');
                GetSynthExamineDetailById({id:item.id}).then(res=>{
                    if(res.code==200){
                        let el=res.data.examineDetailList.find(item=>{
                            return item.resourceType=='0';
                        })
                        if(el){
                            let dialog=this.$refs.view_paper;
                            if(dialog){
                                dialog.paperId=el.resourceId;
                                dialog.getUserAnswerRecord();
                            }
                        }
                    }
                })
            },
        filterStatus(status) {
            var obj = {
                0: {
                    label: '未开始',
                    color: '#C2C7D9'
                },
                1: {
                    label: '进行中',
                    color: '#387DFF'
                },
                2: {
                    label: '已结束',
                    color: '#67C23A'
                },
            }
            return obj[status] || {};
        },
        viewExamineDetail(data){
            GetSynthExamineDetailById({id:data.id}).then(res=>{
                if(res.code==200){
                    this.$store.commit('course/changeOperation','all_examine_detail');  
                    this.$store.commit('backend/changeOptlabel',res.data.examineName);
                    this.$nextTick(()=>{
                            let dom=this.$refs['all_examine_detail'];
                            if(dom){
                                res.data.examineDetailList.forEach(item=>{
                                    item.softwareId=item.resourceId;
                                    delete item.resourceId;
                                })
                                dom.detail=res.data;
                                dom.examineId=data.id;
                                dom.listenerScrool();
                                let examineDetailList=res.data.examineDetailList;
                                if(examineDetailList&&examineDetailList.length>0){
                                    dom.currentSoftwareItem=examineDetailList[0];
                                    dom.pageResData();
                                }else{
                                    dom.currentSoftwareItem={};
                                }
                            }
                        })
                }
            })
        },
        /**查询考核详情 */
        getExamineDetailById(id) {
            return new Promise(resolve => {
                GetExamineDetailById(id).then(res => {
                    if (res.code == 200) {
                        resolve(res.data);
                    }
                })
            })
        },
        /**分页查询考核任务 */
        pageQueryExamine() {
            let params = {
                "classIds": [],
                "current": this.pages.current,
                "examineName": this.pages.keywords,
                "examineStatus": "",
                "examineType": 2,
                "size": this.pages.size
            };
            PageQueryExamine(params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.pages.total = res.data.total;
                }
            })
        },
        /**删除考核 */
        deleteExamine(id) {
            this.$confirm('是否确认删除该条数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                DeleteExamine({ ids: [id] }).then(res => {
                    if (res.code == 200) {
                        this.$msg({
                            showClose: true,
                            type: 'success',
                            message: '删除成功'
                        });
                        if (this.tableData.length == 1 && this.pages.current > 1) {
                            this.pages.current--;
                        }
                        this.pageQueryExamine();
                    }
                })
            });
        },
        /**创建考核 */
        createExamine() {
            this.$store.commit('course/changeOperation', 'all_examine');
            this.$store.commit('backend/changeOptlabel', '创建考核');
            this.examineId = '';
            this.isDetail=false;
        },
        /**切换页码 */
        changeCurrentPage(e) {
            this.pages.current = e;
            this.pageQueryExamine();
        },
        /**切换size */
        changePageSize(e) {
            this.current.size = e;
            this.search();
        },
        /**详情 */
        detail(item) {
            this.isDetail = true;
            this.edit(item,true);
        },
        /**查看考核人员 */
        viewPersonNum(data, type) {
            let dialog = this.$refs.examine_person;
            if (!dialog) return;
            dialog.type = type;
            if (type == 'completed') {
                dialog.getExamineUserInfo(data.id, true);
                return;
            }
            dialog.getExamineUserInfo(data.id, false);
        },
        /**编辑考核 */
        edit(item,isDetail) {
            this.examineId = item.id;
            this.isDetail=isDetail||false;
            this.getExamineDetailById({ id: item.id }).then(res1 => {
                if (res1.extractionMode == '0') {
                    if (res1.paperDetailList && res1.paperDetailList.length > 0) {
                        GetTestPaperInfo({ id: res1.paperDetailList[0].id }).then(res => {
                            if (res.code == 200) {
                                this.$store.commit('course/changeOperation', 'all_examine');
                                this.$store.commit('backend/changeOptlabel', '编辑考核');
                                this.$nextTick(() => {
                                    var dialog = this.$refs.all_examine.$refs.theory_test;
                                    dialog.testId = item.id;
                                    res.data.beginTime = item.beginTime;
                                    res.data.endTime = item.endTime;
                                    res.data.classInfoList = res1.classInfoList;
                                    res.data.answerTime=res1.answerTime;
                                    res.data.passScore=res1.passScore;
                                    res.data.fullScore=res1.fullScore;
                                    res.data.scoreRatio=res1.scoreRatio;
                                    res.data.screenLimit=res1.screenLimit;
                                    dialog.initEditData(res.data);
                                    this.editVirtual(item.id);
                                })
                            }
                        })
                    }
                } else {
                    GetExamineExcludeQuestionIds({ id: item.id }).then(res => {
                        if (res.code == 200) {
                            res1.excludeQuestionIds = res.data;
                            this.$store.commit('course/changeOperation', 'all_examine');
                            this.$store.commit('backend/changeOptlabel', '编辑考核');
                            this.$nextTick(() => {
                                var dialog = this.$refs.all_examine.$refs.theory_test;
                                dialog.testId = item.id;
                                dialog.initPaperEdit(res1);
                                this.editVirtual(item.id);
                            })
                        }
                    })
                }
            })
        },
        editVirtual(id) {
            GetSoftwareConfigScore({ id: id }).then(res => {
                if (res.code == 200) {
                    let dialog = this.$refs.all_examine.$refs.virtual_test;
                    if (dialog) {
                        dialog.examineId = id;
                        dialog.dialogVisible = true;
                        dialog.getClassList();
                        dialog.virtualSoftwarePageList();
                        dialog.examineSoftwareArr = res.data.softwareScoreConfigList.map(item => {
                            return {
                                "fullScore": item.fullScore,
                                "refResourceId": item.softwareId,
                                "resourceType": 1,
                                "classifyCode": '',
                                "options": [],
                                "scoreRatio": item.scoreRatio
                            }
                        });
                    }
                }
            })
        }
    },
    mounted() {
        this.pageQueryExamine();
    },
    destroyed() {
        this.$store.commit('course/changeOperation', '');
        this.$store.commit('backend/changeOptlabel', '');
    }
}
</script>

<style lang="less" scoped>
.out-container {
    height: 100%;
}

.examine-box {
    height: 100%;
}

.top-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.btn-box {
    width: 14rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);

    i {
        margin-right: 3px;
        font-size: 2rem;
    }
}

.input-box {
    display: flex;
    align-items: center;
    color: #8590B3;

    &> :nth-child(1) {
        margin-right: 1rem;
    }

    /deep/.el-input__inner {
        height: 4rem;
        border-radius: 1rem;
        padding-left: 3.5rem;
    }

    .search-ipt-box {
        display: flex;
        align-items: center;
        width: 3.5rem;
        justify-content: center;
        height: 100%;
    }
}

.content-box {
    height: calc(100% - 6rem);
    margin-top: 2rem;
}

.examine-number {
    color: var(--blue);
    cursor: pointer;
}

.operation-box {
    display: flex;
    color: var(--blue);

    &> :nth-child(n) {
        cursor: pointer;
        font-size: 16px;
    }
}
</style>